import aggiungi from './aggiungi'
import switchIn from  './switch-in'
import switchOut from './switch-out'
import pratiche from './pratiche'
import invioLetteraBenvenuto from './invio-lettera-benvenuto'
import dialogVoltura from './dialogVoltura'
import gestioneLetture from './gestione-letture'
import modificaMassiva from './modifica-massiva'
import emettiFattura from './emetti-fattura'
import cambiaOfferta from './cambia-offerta'
import multipods from './multipods'
import multipodsFile from './multipods-file'
import dichiarazioneIva from './dichiarazione-iva'
import prospettoConsumi from './prospetto-consumi'
import rcuUnico from './rcu-unico'
import sommarioConsumiFornitori from './sommario-consumi-fornitori'
import consumiDispacciamento from './consumi-dispacciamento'
import sospensioni from './sospensioni'
import riattivazioni from './riattivazioni'
import daSospendere from './da-sospendere'
import daRiattivare from './da-riattivare'
import aggiungiVociFatturaMassivo from './aggiungi-voci-fattura-massivo'
import caricaConsumiFile from './carica-consumi-file'
import sospensioniSaldate from './sospensioni-saldate'
import rilascioTutela from './rilascioTutela'

export default [
  // always
  {
    key: "pods-button-aggiungi",
    label: "AGGIUNGI FORNITURA",
    classCss: "p-button-secondary uniform-button",    icon: " pi pi-plus",
    type: "operation",
    method: aggiungi,
    display: "always",
    style: {
      width: '120px',
      height: '40px',
    },
  },
  {
    key: "pods-multipod-file",
    label: "MULTIPODS FILE",
    classCss: "p-button-secondary",
    icon: " pi pi-file",
    type: "operation",
    method: multipodsFile,
    display: "always",
  },
  {
    key: "pods-rcu-unico",
    label: "RCU UNICO",
    classCss: "p-button-secondary",
    icon: " pi pi-book",
    type: "operation",
    method: rcuUnico,
    display: "always",
  },
  {
    key: "pods-sommario-consumi-fornitori",
    label: "CONSUMI FORNITORI",
    classCss: "p-button-secondary",
    icon: " pi pi-book",
    type: "operation",
    method: sommarioConsumiFornitori,
    display: "always",
    style: {
      width: '60px',
      height: '80px',
    },
  },
  {
    key: "pods-consumi-dispacciamento-mese",
    label: "CONSUMI DISPACCIAMENTO",
    classCss: "p-button-secondary",
    icon: " pi pi-calendar-plus",
    type: "operation",
    method: consumiDispacciamento,
    display: "always",
  },
  {
    key: "pods-aggiungi-voci-fattura-massivo",
    label: "VOCI FATTURA MASSIVO",
    classCss: "p-button-secondary",
    icon: " pi pi-plus",
    type: "operation",
    method: aggiungiVociFatturaMassivo,
    display: "always",
  },
  {
    key: "pods-carica-consumi-file",
    label: "CARICA CONSUMI FILE",
    classCss: "p-button-secondary",
    icon: 'pi pi-arrow-circle-up',
    type: "operation",
    method: caricaConsumiFile,
    display: "always",
  },
  {
    key: "pods-sospensioni-saldate",
    label: "SOSPENSIONI SALDATE",
    classCss: "p-button-secondary",
    icon: " pi pi-check",
    type: "operation",
    method: sospensioniSaldate,
    display: "always",
  },

  // on-data-filtered
  {
    key: "pods-button-switch-out",
    label: "SWITCH-OUT",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: switchOut,
    display: "on-data-filtered",
  },
  {
    key: "pods-button-switch-in",
    label: "SWITCH-IN",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: switchIn,
    display: "on-data-filtered",
  },
  {
    'key': 'pods-button-pratiche',
    'label': 'PRATICHE',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': pratiche,
    'display': 'on-data-filtered'
  },
   {
     'key': 'dialogVoltura',
     'label': 'VOLTURA',
     'classCss': 'p-button-secondary',
     'icon': ' pi pi-directions',
     'type': 'operation',
     'method': dialogVoltura,
     'display': 'on-data-filtered'
   },
  {
    'key': 'pods-button-lettera-benvenuto',
    'label': 'LETTERA DI BENVENUTO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': invioLetteraBenvenuto,
    'display': 'on-data-filtered'
  },
  {
    key: "pods-button-gestione-lettura",
    label: "GESTIONE LETTURE",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: gestioneLetture,
    display: "on-data-filtered",
  },
  {
    key: "pods-button-modifica-massiva",
    label: "MODIFICA MASSIVA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: modificaMassiva,
    display: "on-data-filtered",
  },
  {
    key: "pods-button-emetti-fattura",
    label: "EMETTI FATTURA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: emettiFattura,
    display: "on-data-filtered",
  },
  {
    key: "pods-button-cambia-offerta",
    label: "CAMBIA OFFERTA",
    classCss: "p-button-secondary",
    icon: " pi pi-directions",
    type: "operation",
    method: cambiaOfferta,
    display: "on-data-filtered",
  },
  {
    key: "pods-multipod",
    label: "MULTIPODS",
    classCss: "p-button-secondary",
    icon: " pi pi-download",
    type: "operation",
    method: multipods,
    display: "on-data-filtered",
  },
  {
    key: "pods-dichiarazione-iva",
    label: "DICHIARAZIONE IVA",
    classCss: "p-button-warning",
    icon: " pi pi-download",
    type: "operation",
    method: dichiarazioneIva,
    display: "on-data-filtered",
  },
  {
    key: "prospetto-consumi",
    label: "Prospetto Consumi",
    classCss: "p-button-success",
    icon: " pi pi-book",
    type: "operation",
    method: prospettoConsumi,
    display: "on-data-filtered",
  },
  {
    key: "pods-sospensioni",
    label: "SOSPENDI",
    classCss: "p-button-warning",
    icon: " pi pi-pause",
    type: "operation",
    method: sospensioni,
    display: "on-data-filtered",
  },
  {
    key: "pods-riattivazioni",
    label: "RIATTIVA",
    classCss: "p-button-primary",
    icon: " pi pi-play",
    type: "operation",
    method: riattivazioni,
    display: "on-data-filtered",
  },
  {
    key: "pods-da-sospendere",
    label: "DA SOSPENDERE",
    classCss: "p-button-warning",
    icon: " far fa-pause-circle",
    type: "operation",
    method: daSospendere,
    display: "on-data-filtered",
    style: {
      width: '120px',
      height: '40px',
    },
  },
  {
    key: "pods-da-riattivare",
    label: "DA RIATTIVARE",
    classCss: "p-button-primary",
    icon: " far far fa-play-circle",
    type: "operation",
    method: daRiattivare,
    display: "on-data-filtered",
  },
  {
    key: "pods-rilascio-tutela",
    label: "RILASCIO TUTELA",
    classCss: "p-button-danger",
    icon: " far fa-pause-circle",
    type: "operation",
    method: rilascioTutela,
    display: "on-data-filtered",
    style: {
      width: '120px',
      height: '40px',
    },
  },
];
